import ShelfController from '../../../core/shelf.controller';

class AuditorController extends ShelfController {
    async initialize() {
        if (this.isAuthenticated) {
            const auditorId = this.props.searchParams.get('id');
            console.log('🔍 Initializing auditor controller:', { auditorId });

            const auditor = await this.data.fetchUserById(auditorId);
            const stores = await this.data.fetchAllStores();

            console.log('🔍 Auditor data loaded:', {
                auditor: auditor,
                auditorId: auditor?._id,
                totalStores: stores?.length,
                storesWithAuditor: stores?.filter((store) => store.auditor)?.length,
                auditorStores: stores?.filter((store) => store.auditor === auditor?._id)?.length,
                sampleStores: stores?.slice(0, 3)?.map((store) => ({
                    id: store._id,
                    name: store.name,
                    auditor: store.auditor,
                    auditorMatch: store.auditor === auditor?._id,
                })),
            });

            this.setState({ auditor, stores, loading: false });
        } else this.navigateLogin();
    }

    // Opens this auditor's drill-down in the audit console.
    openInAuditConsole() {
        const { auditor } = this.state;
        this.props.navigate(`/dashboard/trade/audit-console?tab=auditors&auditor=${auditor?._id}`);
    }

    async updateStores(selectedStores, removedStores, userId) {
        try {
            console.log('🔄 Updating auditor stores:', { selectedStores, removedStores, userId });

            // ✅ Add stores to auditor
            if (selectedStores?.length > 0) {
                console.log('➕ Adding stores to auditor:', selectedStores);
                await Promise.all(
                    selectedStores?.map(async (store) => {
                        console.log('➕ Adding store to auditor:', { store, auditor: userId });
                        await this.data.updateStoreAuditor({ id: store, auditor: userId });
                    })
                );
            }

            // ✅ Remove stores from auditor
            if (removedStores?.length > 0) {
                console.log('➖ Removing stores from auditor:', removedStores);
                await Promise.all(
                    removedStores?.map(async (st) => {
                        console.log('➖ Removing store from auditor:', { store: st, auditor: null });
                        await this.data.updateStoreAuditor({ id: st, auditor: null });
                    })
                );
            }

            console.log('✅ Auditor stores updated successfully');
        } catch (err) {
            console.error('❌ Error updating auditor stores:', err);
        } finally {
            window.location.reload();
        }
    }
}

export default AuditorController;
